import dayjs from 'dayjs';

import { Range } from '../entity/common';
import { OpenHour } from '../entity/venue';

// Convert each time to minutes since midnight UTC
export const toMinutes = (time: Date | string): number => {
  if (typeof time === 'string') {
    time = new Date(time);
  }
  return time.getUTCHours() * 60 + time.getUTCMinutes();
};

export const isTimeBetweenSlot = (target: Date, slot: Range<Date>): boolean => {
  const targetMins = toMinutes(target);
  const startMins = toMinutes(slot.from);
  const endMins = toMinutes(slot.to);

  // Check if the range crosses midnight
  if (startMins <= endMins) {
    return targetMins >= startMins && targetMins <= endMins;
  } else {
    return targetMins >= startMins || targetMins <= endMins;
  }
};

export const isSame = (r1: Range<Date> | Range<string>, r2: Range<Date> | Range<string>) =>
  dayjs(r1.from).isSame(r2.from) && dayjs(r1.to).isSame(r2.to);

export const isIntervalBetweenOpenHour = (target: Range<Date | string>, openHour: OpenHour): boolean => {
  const targetStartMins = toMinutes(target.from);
  const targetEndMins = toMinutes(target.to);
  const openTime = openHour.from;
  const closeTime = openHour.to;

  // Case 1: Interval a-b does NOT wrap around midnight
  if (openTime <= closeTime) {
    return targetStartMins >= openTime && targetEndMins <= closeTime;
  }
  // Case 2: Interval a-b wraps around midnight
  else {
    // Subcase 1: Target interval x-y does NOT wrap around midnight
    if (targetStartMins <= targetEndMins) {
      return (
        (targetStartMins >= openTime && targetEndMins <= 1440) || // x-y within [a, 24:00)
        (targetStartMins >= 0 && targetEndMins <= closeTime) // x-y within [00:00, b]
      );
    }
    // Subcase 2: Target interval x-y wraps around midnight
    else {
      return targetStartMins >= openTime && targetEndMins <= closeTime;
    }
  }
};

export const getPrettyDateString = (batch?: Range<Date>) => {
  if (!batch) {
    return '';
  }
  const from = dayjs(batch.from);
  const to = dayjs(batch.to);

  return `${from.format('DD/MM/YY, hh:mm a')} - ${to.format(from.isSame(to, 'date') ? 'hh:mm a' : 'DD/MM/YY, hh:mm a')}`;
};

export const convertToUrlFriendlyName = (title: string) => title.replace(/\s/g, '+');

export const convertUrlFriendlyNameToTitle = (title: string) => decodeURIComponent(title).replace(/\+/g, ' ');
